import api from './api'
/*
  Funzione che verifica l'esistenza di un'azienda.
  In caso di esistenza ritorna l'azienda esistente,
  altrimenti la crea e ritorna l'azienda appena creata
*/
export default async function getExistingCompany (vatCode, referentPhoneNumber, taxId, name, referentFullName, referentEmail) {
  const existentCompanies = await api.getResource('companies', { params: { vatId: vatCode } })
  const normalizeTaxId = (currentTaxId) => (currentTaxId || '').trim().toUpperCase()
  const normalizedTaxId = normalizeTaxId(taxId)

  if (existentCompanies.length > 0) {
    const reusableCompany = existentCompanies.find((company) => {
      const existingTaxId = normalizeTaxId(company.taxId)

      // Se il codice fiscale non e' valorizzato oppure coincide, riutilizziamo la company.
      return !existingTaxId || existingTaxId === normalizedTaxId
    })

    if (reusableCompany) return reusableCompany
  }

  const companyBody = {
    name: name,
    status: 'inactive',
    vatId: vatCode,
    referentPhoneNumber,
    referentFullName,
    referentEmail,
    taxId,
    email: referentEmail
  }

  const company = await api.postResource('companies', { body: companyBody })
  return company
}
